module.exports = __webpack_public_path__ + "0f7c77932ea877aca544e439a3e63bb6.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/opensans-regular/opensans-regular.woff
// module id = ./src/styles/fonts/opensans-regular/opensans-regular.woff
// module chunks = index